<template>
    <div class="record-file-upload">
        <div class="collapse-body">
            <h3>Dateien</h3>

            <div class="row">
                <div class="col-md-6 align-self-center">
                    <b-form-group label="Zuordnung">
                        <b-form-select
                            v-model="selectedCategoryGroup"
                            :options="categoryGroupOptions"
                            :required="true"/>
                    </b-form-group>
                    <b-form-group label="Kategorie">
                        <b-form-select
                            v-model="selectedCategory"
                            :disabled="!selectedCategoryGroup"
                            :options="categoryOptions"
                            :required="true"/>
                    </b-form-group>
                </div>
                <div class="col-md-6 align-self-center">
                    <div class="form-group">
                        <csp-record-file-upload
                            ref="dropzone"
                            :category="selectedCategory"
                            :category-group="selectedCategoryGroup"
                            :multiple-upload="true"
                            :record-id="recordId"
                            @upload-success="handleUploadSuccess"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import {prependEmptyOption} from '@js/functions/form/select';
    import FileRepository from '../../../lib/repositories/file/FileRepository';
    import FileCategoryEnum from '@js/enums/file/FileCategoryEnum';
    import FileCategoryGroupEnum from '@js/enums/file/FileCategoryGroupEnum';

    const container = Container.getInstance();
    const eventBus = container.getEventBus();
    const fileCategoryGroupRepository = container.getFileCategoryGroupRepository();
    const fileCategoryRepository = container.getFileCategoryRepository();

    export default {
        props: {
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: [
            'upload-success',
        ],
        data() {
            return {
                categoryGroupOptions: [],
                categoryOptions: [],

                selectedCategoryGroup: null,
                selectedCategory: null,
            }
        },
        watch: {
            selectedCategoryGroup(newValue) {
                this.selectedCategory = null;

                if (newValue !== null) {
                    fileCategoryRepository.findCategoriesDependingOnGroup(
                        this.selectedCategoryGroup,
                        this.recordId
                    )
                        .then(async(options) => {
                            this.categoryOptions = await prependEmptyOption(options);
                        })
                }
            },
        },
        mounted() {
            this.loadCategoryGroups();
        },
        methods: {
            resetCategoryAfterUpload() {
                if (this.selectedCategory == FileCategoryEnum.PICTURE
                    && this.selectedCategoryGroup == FileCategoryGroupEnum.VEHICLE)
                {
                    this.$bvModal.msgBoxConfirm('Weitere Bilder hochladen?', {
                        okTitle: 'Ja',
                        cancelTitle: 'Nein',
                        centered: true,
                    }).then(value => {
                        if (value) {
                            this.$refs.dropzone.$el.click()
                        }
                        else {
                            this.selectedCategory = null;
                            this.selectedCategoryGroup = null;
                        }
                    })
                }
                else {
                    this.selectedCategory = null;
                    this.selectedCategoryGroup = null;
                }
            },
            handleUploadSuccess(data) {
                this.$emit('upload-success', data);
                eventBus.emit(FileRepository.EVENT_UPLOAD_SUCCESS);
                this.resetCategoryAfterUpload()
            },
            loadCategoryGroups() {
                fileCategoryGroupRepository.findForDropdown(this.recordId)
                    .then(async(options) => {
                        this.categoryGroupOptions = await prependEmptyOption(options);
                    });
            },
        },
    }
</script>
